import { useTooltipTriggerProps as _ } from "./index688.js";
import { defineComponent as w, inject as B, ref as K, toRef as y, openBlock as b, createBlock as D, unref as e, normalizeClass as F, withCtx as I, renderSlot as N, nextTick as R } from "vue";
import { TOOLTIP_INJECTION_KEY as P } from "./index691.js";
import { whenTrigger as i } from "./index794.js";
import { composeEventHandlers as t, getEventCode as S } from "./index589.js";
import $ from "./index560.js";
import { useNamespace as j } from "./index559.js";
import { focusElement as z } from "./index566.js";
var Q = /* @__PURE__ */ w({
  name: "ElTooltipTrigger",
  __name: "trigger",
  props: _,
  setup(l, { expose: f }) {
    const s = l, m = j("tooltip"), { controlled: p, id: d, open: v, onOpen: u, onClose: a, onToggle: c } = B(
      P,
      void 0
    ), C = K(null), n = () => {
      if (e(p) || s.disabled)
        return !0;
    }, r = y(s, "trigger"), T = t(
      n,
      i(r, "hover", (o) => {
        u(o), s.focusOnTarget && o.target && R(() => {
          z(o.target, { preventScroll: !0 });
        });
      })
    ), x = t(
      n,
      i(r, "hover", a)
    ), k = t(
      n,
      i(r, "click", (o) => {
        o.button === 0 && c(o);
      })
    ), M = t(
      n,
      i(r, "focus", u)
    ), h = t(
      n,
      i(r, "focus", a)
    ), E = t(
      n,
      i(r, "contextmenu", (o) => {
        o.preventDefault(), c(o);
      })
    ), O = t(
      n,
      (o) => {
        const g = S(o);
        s.triggerKeys.includes(g) && (o.preventDefault(), c(o));
      }
    );
    return f({
      /**
       * @description trigger element
       */
      triggerRef: C
    }), (o, g) => (b(), D(e($), {
      id: e(d),
      "virtual-ref": l.virtualRef,
      open: e(v),
      "virtual-triggering": l.virtualTriggering,
      class: F(e(m).e("trigger")),
      onBlur: e(h),
      onClick: e(k),
      onContextmenu: e(E),
      onFocus: e(M),
      onMouseenter: e(T),
      onMouseleave: e(x),
      onKeydown: e(O)
    }, {
      default: I(() => [
        N(o.$slots, "default")
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["id", "virtual-ref", "open", "virtual-triggering", "class", "onBlur", "onClick", "onContextmenu", "onFocus", "onMouseenter", "onMouseleave", "onKeydown"]));
  }
});
export {
  Q as default
};
